var map = {
	"./chat-with-customers.json": 592,
	"./create-and-manage-canned-responses.json": 593,
	"./evaluate-agent-activity.json": 594,
	"./evaluate-queue-activity.json": 595,
	"./guide-customers-via-co-browsing.json": 596,
	"./handle-a-phone-call.json": 597,
	"./manage-all-admin-duties-from-one-place.json": 598,
	"./manage-people-in-your-organization.json": 599,
	"./manage-queue-behavior-thresholds-and-membership.json": 600,
	"./manage-voice-interactions.json": 601,
	"./monitor-evaluation-and-calibration-activity.json": 602,
	"./monitor-real-time-activity.json": 603,
	"./navigate-queue-performance.json": 604,
	"./view-evaluation-statuses-and-action-items.json": 605,
	"./view-queue-activity-detail.json": 606,
	"./view-queue-performance-detail.json": 607,
	"./view-real-time-adherence.json": 608,
	"./view-your-performance.json": 609
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 591;


//////////////////
// WEBPACK FOOTER
// ./src/data/scenes .json
// module id = 591
// module chunks = 0